import { Row } from "antd";
import Container from "../../common/Container";
import {
  HeaderSection,
  LogoContainer,
  NotHidden,
  CustomNavLinkSmall,
  Span,
} from "./styles";
import { Button } from "../../common/Button";

const Header = () => {
  const MenuItem = () => {
    return (
      <>
        <CustomNavLinkSmall
          onClick={() => window.location.href = "https://www.buyupvotes.io/?source_ref_id=113"}
        >
          <Span>
            <Button>Buy Reddit Accounts</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <img
              src="img/logo/logo-full.png"
              alt="Buy Reddit Accounts"
              width="240px"
              height="64px"
              style={{ objectFit: 'contain' }}
            />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
        </Row>
      </Container>
    </HeaderSection>
  );
};

export default Header;
